// class ClickEvent {
//     constructor(el,opt){
//       this.el = el;
//       if($("." + this.el).length > 0){
//         this.event();
//       }
//     }
//     event(){

// 			function clickEvent(){
// 				const career = document.querySelectorAll(".job-career__btn.selet-btn");
// 				const jobKind = document.querySelectorAll(".job-kind__btn");
// 				const stylist = document.querySelector(".js-stylist");


// 				career.forEach(item => {
// 					item.addEventListener("click", () => {
// 						career.forEach(allChecks => {
// 							if(allChecks.classList.contains("is-active")){
// 								allChecks.classList.remove("is-active")
// 							}
// 						});
// 						item.classList.add("is-active")
// 					})

// 				});

// 				jobKind.forEach(item => {
// 					item.addEventListener("click", () => {
// 						jobKind.forEach(allChecks => {
// 							if(allChecks.classList.contains("is-active")){
// 								allChecks.classList.remove("is-active")
// 							}
// 						});
// 						item.classList.add("is-active")
// 						if(item === career[0]  && item.classList.contains("is-active") && jobKind[0].classList.contains("is-active")){
// 							stylist.textContent = "aaa";
// 						}
// 					})
// 				});
// 			}

// 			function selectEvent(){

// 				const jobContent = document.querySelectorAll('.job-content');
// 				const careerBtn = document.querySelectorAll('.job-career__btn');
// 				const kindBtn = document.querySelectorAll('.job-kind__btn');
// 				let career;
// 				let job;


// 				$(".job-career input, .job-kind input").on("click", function() {
// 					careerBtn.forEach(function(el) {
// 					if(el.classList.contains("is-active")) {
// 						career = el.getAttribute('value');
// 						}
// 					})
// 					kindBtn.forEach(function(el) {
// 					if(el.classList.contains("is-active")) {
// 						job = el.getAttribute('value');
// 					}
// 					})
// 					jobContent.forEach(function(el) {
// 					el.style.display = "none";
// 					if(career == el.getAttribute("data-recruit") && job == el.getAttribute("data-job")) {
// 						el.style.display = "flex";
// 					}
// 					})


// 					})

// 			}
// 			clickEvent();

// 			selectEvent();
//     }

//   }

